module.exports = __webpack_public_path__ + "static/media/studion.5829818a.svg";